import { render, staticRenderFns } from "./AdminOrderItemRow.vue?vue&type=template&id=1315eea6"
import script from "./AdminOrderItemRow.vue?vue&type=script&lang=js"
export * from "./AdminOrderItemRow.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/gl-api/api.greenlists.com/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1315eea6')) {
      api.createRecord('1315eea6', component.options)
    } else {
      api.reload('1315eea6', component.options)
    }
    module.hot.accept("./AdminOrderItemRow.vue?vue&type=template&id=1315eea6", function () {
      api.rerender('1315eea6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/components/AdminOrderItemRow.vue"
export default component.exports